export enum IntentClientSecretType {
  SETUP = "SETUP",
  PAYMENT = "PAYMENT",
}

/**
   * Get the type of the intent from the client secret
   * @param intentClientSecret - The client secret of the intent
   * @returns The type of the intent
   */
export const getIntentClientSecretType =
  (intentClientSecret: string): IntentClientSecretType | null => {
    if (intentClientSecret.startsWith("seti_")) {
      return IntentClientSecretType.SETUP;
    }
    if (intentClientSecret.startsWith("pi_")) {
      return IntentClientSecretType.PAYMENT;
    }
    return null;
  };

export const formatIntentType = (intentType: IntentClientSecretType | null): string => {
  if (intentType === IntentClientSecretType.SETUP) { return "Setup"; }
  if (intentType === IntentClientSecretType.PAYMENT) { return "Payment"; }
  return "Unknown";
};
